// Question data for check-in dialogs

export const dailyCheckinQuestions = [
  {
    id: 'mood',
    prompt: 'How are you feeling today?',
    icons: ['😣', '😒', '😑', '🙂', '😁'],
    labels: ['Upset', 'Down', 'Neutral', 'Good', 'Great'],
    type: 'emoji-scale',
  },
  {
    id: 'sleep',
    prompt: 'How about your sleep quality?',
    icons: ['😪', '🥱', '😐', '😏', '😜'],
    labels: ['Poor', 'Not Good', 'So-So', 'Rested', 'Amazing'],
    type: 'emoji-scale',
  },
  {
    id: 'stress',
    prompt: 'How would you describe your stress level?',
    icons: ['😀', '😌', '😐', '😰', '😱'],
    labels: ['No Stress', 'Pretty Low', 'Not Bad', 'Stressed', 'Very Stressed'],
    type: 'emoji-scale',
  },
  {
    id: 'domain',
    prompt: 'Is there any domain in your life you feel needs improvement?',
    icons: ['💪', '😀', '💵', '👩‍❤️‍👩', '🩷', '💭'],
    labels: ['Physical', 'Emotional', 'Acceptance', 'Relationships', 'Loving-Kindness', 'Intellectual'],
    tooltips: [
      'This domain encompasses your physical health and well-being, including exercise, nutrition, and overall bodily vitality.',
      'This domain focuses on your emotional state, including mood regulation, resilience, and emotional intelligence.',
      'This relates to your financial well-being, including financial security, stability, and management of resources.',
      'This includes your social connections, relationships with family, friends, and community.',
      'This focuses on compassion and goodwill towards yourself and others, fostering empathy and kindness.',
      'This area encompasses your mental stimulation and growth, including learning, creativity, and intellectual pursuits.',
    ],
    type: 'emoji-scale-with-tooltips',
  },
];

export const growthProgressQuestions = [
  {
    id: 'accomplished',
    prompt: 'List your specific, unique accomplishments',
    placeholders: [
      'e.g., Finished the client proposal',
      'e.g., Ran 5 miles',
      'e.g., Helped a colleague',
    ],
  },
  {
    id: 'learned',
    prompt: 'List specific knowledge you gained',
    placeholders: [
      'e.g., How to use the new software feature',
      'e.g., A new historical fact',
      'e.g., A better way to approach a conversation',
    ],
  },
  {
    id: 'enjoyed',
    prompt: 'List specific enjoyable moments',
    placeholders: [
      'e.g., Morning coffee break',
      'e.g., That funny video I saw',
      'e.g., Dinner with my family',
    ],
  },
];

export const reflectDayQuestions = [
  {
    id: 'day_rating',
    prompt: 'How would you rate your day today?',
  },
  {
    id: 'productivity',
    prompt: 'How productive did you feel?',
  },
  {
    id: 'creativity',
    prompt: 'How creative did you feel?',
  },
];

// Emoji-based rating scale for Reflect Your Day
export const reflectRatingScale = [
  {
    value: 1,
    emoji: '😞',
    label: 'Poor',
    description: 'Poor / Low: Significantly below expectations. A challenging or unproductive experience.',
  },
  {
    value: 2,
    emoji: '😕',
    label: 'Needs Improvement',
    description: 'Needs Improvement: Below average. Felt somewhat constrained or struggled to meet goals.',
  },
  {
    value: 3,
    emoji: '😐',
    label: 'Average',
    description: "Average / Neutral: Just okay. Met baseline expectations but didn't feel particularly good or bad.",
  },
  {
    value: 4,
    emoji: '😊',
    label: 'Good',
    description: 'Good / High: Above average. Felt successful, productive, or had moments of strong performance.',
  },
  {
    value: 5,
    emoji: '😄',
    label: 'Excellent',
    description: 'Excellent / Peak: Exceptional. A fantastic day; felt incredibly productive, inspired, and on top of things.',
  },
];

// Audio sources for guidance
export const audioSources = {
  dailyCheckin:
    "https://storage.googleapis.com/mindsherpa-app-bucket/audios/morning-audio-with-background-music.MP3",
  growthProgress:
    "https://storage.googleapis.com/mindsherpa-app-bucket/audios/Mid-day-with-background-music.MP3",
  reflectDay:
    "https://storage.googleapis.com/mindsherpa-app-bucket/audios/Evening-with-background-music.MP3",
};
